import React, { useState } from "react";

import Container from "../components/Container";
import ContentTemplate from "../components/Layout/contentTemplate";
import { Context } from "../utils/store";
import Head from "next/head";
import Layout from "../components/Layout";
import Link from "next/link";
import TopicHeader from "../components/TopicHeader";
import fetchRequestLibrary from "../utils/fetchRequestLibrary";
import { siteTitle } from "../components/Layout";
import { useContext } from "react";
import CustomHead from '../components/CustomHead';

export default function Sitemap({
  thematiques,
  breakingNews,
  cities,
  ephemeralChannels,
  liveData,
  medias,
}) {
  const context = useContext(Context);
  return (
    <Context.Provider
      value={{
        ...context,
        activePage: "sitemap",
        thematiques,
        breakingNews,
        cities,
        ephemeralChannels,
        liveData,
        medias,
      }}
    >
      <Layout>
        <Container>
          <CustomHead title="Plan du site"/>
          <ContentTemplate type={"sitemap"}>
            <TopicHeader topic={"Sitemap"} type={"sitemap"} />
            <div className="flex flex-col">
              {thematiques &&
                thematiques.items &&
                thematiques.items.map((e, i) => {
                  return (
                    <Link
                      key={i}
                      as={{ pathname: `/${e.uri}` }}
                      href={{
                        pathname: `/thematiques/[uri]`,
                      }}
                    >
                      <a className="sitemap-link">{e.pagetitle}</a>
                    </Link>
                  );
                })}
            <Link
                as={{ pathname: `emissions` }}
                href={{
                  pathname: `/emissions`,
                }}
              >
                <a className="sitemap-link">{"Émissions"}</a>
              </Link>
              <Link
                as={{ pathname: `direct` }}
                href={{
                  pathname: `/direct`,
                }}
              >
                <a className="sitemap-link">{"Direct"}</a>
              </Link>
              <Link
                as={{ pathname: `autour-de-moi` }}
                href={{
                  pathname: `/autour-de-moi`,
                }}
              >
                <a className="sitemap-link">{"Autour de moi"}</a>
              </Link>
              <Link
                as={{ pathname: `contact` }}
                href={{
                  pathname: `/contact`,
                }}
              >
                <a className="sitemap-link">{"Contact"}</a>
              </Link>
              <Link
                as={{ pathname: `a-propos` }}
                href={{
                  pathname: `/a-propos`,
                }}
              >
                <a className="sitemap-link">{"A propos de nous"}</a>
              </Link>
              <Link
                as={{ pathname: `recevoir-la-chaine` }}
                href={{
                  pathname: `/recevoir-la-chaine`,
                }}
              >
                <a className="sitemap-link">{"Recevoir la chaîne"}</a>
              </Link>
            </div>
          </ContentTemplate>
        </Container>
      </Layout>
    </Context.Provider>
  );
}

export async function getServerSideProps(context) {
  const {
    thematiques,
    breakingNews,
    cities,
    ephemeralChannels,
    liveData,
    medias,
  } = await fetchRequestLibrary();

  return {
    props: {
      thematiques,
      breakingNews,
      cities,
      ephemeralChannels,
      liveData,
      medias,
    },
  };
}
